import { render, staticRenderFns } from "./post_list.vue?vue&type=template&id=ab06ddf4&scoped=true&"
import script from "./post_list.vue?vue&type=script&lang=js&"
export * from "./post_list.vue?vue&type=script&lang=js&"
import style0 from "./post_list.vue?vue&type=style&index=0&lang=css&"
import style1 from "./post_list.vue?vue&type=style&index=1&id=ab06ddf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab06ddf4",
  null
  
)

export default component.exports